import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@cloudscape-design/global-styles/index.css';
import { ServiceLayout } from './layouts/ServiceLayout';
import { StoreList } from './pages/StoreList';
import { CreateStore } from './pages/CreateStore';
import { StoreDetail } from './pages/StoreDetail';
import { LineageGraph } from './pages/LineageGraph';
import { Explorer } from './pages/Explorer';
import { ViewDetail } from './pages/ViewDetail';
import { ViewList } from './pages/ViewList';
import { StoreDetailStreamRedirect } from './components/StoreDetailStreamRedirect';
import { initAuth } from './api/auth';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchInterval: 10000 } },
});

export function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    initAuth().then((result) => {
      setAuthenticated(result);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Authenticating...</div>;
  }

  if (!authenticated) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Redirecting to login...</div>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ServiceLayout>
          <Routes>
            <Route path="/" element={<StoreList />} />
            <Route path="/stores" element={<StoreList />} />
            <Route path="/stores/create" element={<CreateStore />} />
            <Route path="/stores/:storeName/lineage/:eventId" element={<LineageGraph />} />
            <Route path="/stores/:storeName/schemas/:eventType" element={<StoreDetail />} />
            <Route path="/stores/:storeName/rules/:ruleName" element={<StoreDetail />} />
            <Route path="/stores/:storeName/events/:eventId" element={<StoreDetail />} />
            <Route path="/stores/:storeName/streams/:streamKey" element={<StoreDetailStreamRedirect />} />
            <Route path="/stores/:storeName" element={<StoreDetail />} />
            <Route path="/views" element={<ViewList />} />
            <Route path="/views/:viewName/schemas/:eventType" element={<ViewDetail />} />
            <Route path="/views/:viewName/rules/:ruleName" element={<ViewDetail />} />
            <Route path="/views/:viewName" element={<ViewDetail />} />
            <Route path="/explorer" element={<Explorer />} />
          </Routes>
        </ServiceLayout>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
